import "@/index.css";
import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CartProvider } from "@/lib/cart";
import { AuthProvider } from "@/lib/auth";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Pathways from "@/components/Pathways";
import LabStandards from "@/components/LabStandards";
import FeaturedSkus from "@/components/FeaturedSkus";
import Quality from "@/components/Quality";
import Wholesale from "@/components/Wholesale";
import Compliance from "@/components/Compliance";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import CheckoutModal from "@/components/CheckoutModal";
import EntryGate from "@/components/EntryGate";
import AuthCallback from "@/components/AuthCallback";
import CatalogPage from "@/pages/CatalogPage";
import TrackOrder from "@/pages/TrackOrder";
import CoaLibrary from "@/pages/CoaLibrary";
import Suppliers from "@/pages/Suppliers";
import PayPage from "@/pages/PayPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

const Home = () => (
  <main>
    <Hero />
    <Marquee />
    <Pathways />
    <LabStandards />
    <FeaturedSkus />
    <Quality />
    <Wholesale />
    <Compliance />
  </main>
);

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo({ top: 0 }); return; }
    const target = () => document.querySelector(hash);
    const jump = (smooth) => target()?.scrollIntoView({ behavior: smooth ? "smooth" : "auto", block: "start" });
    const t1 = setTimeout(() => jump(true), 150);
    const ro = new ResizeObserver(() => jump(false));
    ro.observe(document.body);
    const stop = setTimeout(() => ro.disconnect(), 2500);
    return () => { clearTimeout(t1); clearTimeout(stop); ro.disconnect(); };
  }, [pathname, hash]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/catalog" element={<CatalogPage />} />
      <Route path="/track" element={<TrackOrder />} />
      <Route path="/coa-library" element={<CoaLibrary />} />
      <Route path="/suppliers" element={<Suppliers />} />
      <Route path="/pay/:orderId" element={<PayPage />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#FAFAFA]">
            <ScrollManager />
            <Header />
            <AppRouter />
            <Footer />
            <CartDrawer />
            <CheckoutModal />
            <EntryGate />
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
